import Icon from '../components/Icon.vue'

Icon.register({
  phone: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M493.4 24.6c10.9 2.5 18.6 12.2 18.6 23.4 0 256.5-207.9 464-464 464-11.3 0-20.9-7.8-23.4-18.6l-24-104c-2.6-11.3 3.3-22.9 14-27.6l112-48c9.8-4.2 21.2-1.4 28 6.9l49.6 60.6c78.3-36.7 141.2-100.5 177.2-177.2l-60.6-49.6c-8.3-6.7-11.1-18.2-6.9-28l48-112c4.6-10.6 16.2-16.5 27.5-13.9z'
      }
    ]
  }
})
